import {
  FormArray,
  FormControl,
  FormGroup,
  AbstractControl,
  Validators,
} from '@angular/forms';

export class FormValidations {
  static ValidaCpf(controle: FormControl) {
    let cpf = '';
    if (controle.value !== null) {
      var numbers = controle.value.match(/\d/g);
      if (numbers) cpf = numbers.join('');
    }
    if (cpf && cpf !== '' && cpf.length === 11) {
      let numbers, digits, sum, i, result, equalDigits;
      equalDigits = 1;
      if (cpf.length < 11) {
        return { cpfInvalido: true };
      }

      for (i = 0; i < cpf.length - 1; i++) {
        if (cpf.charAt(i) !== cpf.charAt(i + 1)) {
          equalDigits = 0;
          break;
        }
      }

      if (!equalDigits) {
        numbers = cpf.substring(0, 9);
        digits = cpf.substring(9);
        sum = 0;
        for (i = 10; i > 1; i--) {
          sum += numbers.charAt(10 - i) * i;
        }

        result = sum % 11 < 2 ? 0 : 11 - (sum % 11);

        if (result !== Number(digits.charAt(0))) {
          return { cpfInvalido: true };
        }
        numbers = cpf.substring(0, 10);
        sum = 0;

        for (i = 11; i > 1; i--) {
          sum += numbers.charAt(11 - i) * i;
        }
        result = sum % 11 < 2 ? 0 : 11 - (sum % 11);

        if (result !== Number(digits.charAt(1))) {
          return { cpfInvalido: true };
        }
        return null;
      } else {
        return { cpfInvalido: true };
      }
    }
  }

  static ValidaCnpj(controle: FormControl) {
    let cnpj = '';
    if (controle.value !== null) {
      var numbers = controle.value.match(/\d/g);

      cnpj = numbers.join('');
    }

    if (cnpj && cnpj !== '' && cnpj.length === 14) {
      let valido = false;
      // Elimina CNPJs invalidos conhecidos
      if (
        cnpj == '00000000000000' ||
        cnpj == '11111111111111' ||
        cnpj == '22222222222222' ||
        cnpj == '33333333333333' ||
        cnpj == '44444444444444' ||
        cnpj == '55555555555555' ||
        cnpj == '66666666666666' ||
        cnpj == '77777777777777' ||
        cnpj == '88888888888888' ||
        cnpj == '99999999999999'
      )
        valido = false;

      // Valida DVs
      let tamanho = cnpj.length - 2;
      let numeros: any = cnpj.substring(0, tamanho);
      let digitos: any = cnpj.substring(tamanho);
      let soma = 0;

      let pos = tamanho - 7;
      for (let i = tamanho; i >= 1; i--) {
        soma += numeros.charAt(tamanho - i) * pos--;
        if (pos < 2) pos = 9;
      }
      let resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);
      if (resultado != digitos.charAt(0)) valido = false;

      tamanho = tamanho + 1;
      numeros = cnpj.substring(0, tamanho);
      soma = 0;
      pos = tamanho - 7;
      for (let i = tamanho; i >= 1; i--) {
        soma += numeros.charAt(tamanho - i) * pos--;
        if (pos < 2) {
          pos = 9;
        }
      }
      resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);
      if (resultado != digitos.charAt(1)) {
        valido = false;
      } else {
        valido = true;
      }
      return valido ? false : { cnpjInvalido: true };
    }
  }

  static MaiorQue18Anos(controle: AbstractControl) {
    const nascimento = controle.value;
    const [ano, mes, dia] = nascimento.split('-');
    const hoje = new Date();
    const dataNascimento = new Date(ano, mes, dia, 0, 0, 0);
    const tempoParaTeste = 1000 * 60 * 60 * 24 * 365 * 18; //18 anos em mili segundos...

    if (hoje.getTime() - dataNascimento.getTime() >= tempoParaTeste)
      return null;

    return { menorDeIdade: true };
  }

  static NomeCompleto(controle: AbstractControl) {
    let valor = controle.value.match(
      /^[A-Za-záàâãéèêíïóôõöúçñ]{2,} [A-Za-záàâãéèêíïóôõöúçñ ].*$/g
    );
    if (valor) return null;
    return { nomeCompletoInvalido: true };
  }

  static ValidaCpfCnpj(controle: FormControl) {
    let cpf = '';
    if (controle.value !== null) {
      var numbers = controle.value.match(/\d/g);

      cpf = numbers.join('');
    }

    if (cpf.length < 11) {
      return { cpfInvalido: true };
    } else if (cpf && cpf !== '' && cpf.length === 11) {
      let numbers, digits, sum, i, result, equalDigits;
      equalDigits = 1;
      if (cpf.length < 11) {
        return { cpfInvalido: true };
      }

      for (i = 0; i < cpf.length - 1; i++) {
        if (cpf.charAt(i) !== cpf.charAt(i + 1)) {
          equalDigits = 0;
          break;
        }
      }

      if (!equalDigits) {
        numbers = cpf.substring(0, 9);
        digits = cpf.substring(9);
        sum = 0;
        for (i = 10; i > 1; i--) {
          sum += numbers.charAt(10 - i) * i;
        }

        result = sum % 11 < 2 ? 0 : 11 - (sum % 11);

        if (result !== Number(digits.charAt(0))) {
          return { cpfInvalido: true };
        }
        numbers = cpf.substring(0, 10);
        sum = 0;

        for (i = 11; i > 1; i--) {
          sum += numbers.charAt(11 - i) * i;
        }
        result = sum % 11 < 2 ? 0 : 11 - (sum % 11);

        if (result !== Number(digits.charAt(1))) {
          return { cpfInvalido: true };
        }
        return null;
      } else {
        return { cpfInvalido: true };
      }
    } else if (cpf.length < 14) {
      return { cnpjInvalido: true };
    } else if (cpf && cpf !== '' && cpf.length === 14) {
      let cnpj: string = cpf;

      let valido = false;
      // Elimina CNPJs invalidos conhecidos
      if (
        cnpj == '00000000000000' ||
        cnpj == '11111111111111' ||
        cnpj == '22222222222222' ||
        cnpj == '33333333333333' ||
        cnpj == '44444444444444' ||
        cnpj == '55555555555555' ||
        cnpj == '66666666666666' ||
        cnpj == '77777777777777' ||
        cnpj == '88888888888888' ||
        cnpj == '99999999999999'
      )
        valido = false;

      // Valida DVs
      let tamanho = cnpj.length - 2;
      let numeros: any = cnpj.substring(0, tamanho);
      let digitos: any = cnpj.substring(tamanho);
      let soma = 0;

      let pos = tamanho - 7;
      for (let i = tamanho; i >= 1; i--) {
        soma += numeros.charAt(tamanho - i) * pos--;
        if (pos < 2) pos = 9;
      }
      let resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);
      if (resultado != digitos.charAt(0)) valido = false;

      tamanho = tamanho + 1;
      numeros = cnpj.substring(0, tamanho);
      soma = 0;
      pos = tamanho - 7;
      for (let i = tamanho; i >= 1; i--) {
        soma += numeros.charAt(tamanho - i) * pos--;
        if (pos < 2) {
          pos = 9;
        }
      }
      resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);
      if (resultado != digitos.charAt(1)) {
        valido = false;
      } else {
        valido = true;
      }
      return valido ? false : { cnpjInvalido: true };
    }
  }

  static cpfcnpjmask(rawValue) {
    try {
      var numbers = rawValue.match(/\d/g);
      var numberLength = 0;
      if (numbers) {
        numberLength = numbers.join('').length;
      }
      if (numberLength <= 11) {
        return [
          /[0-9]/,
          /[0-9]/,
          /[0-9]/,
          '.',
          /[0-9]/,
          /[0-9]/,
          /[0-9]/,
          '.',
          /[0-9]/,
          /[0-9]/,
          /[0-9]/,
          '-',
          /[0-9]/,
          /[0-9]/,
        ];
      } else {
        return [
          /[0-9]/,
          /[0-9]/,
          '.',
          /[0-9]/,
          /[0-9]/,
          /[0-9]/,
          '.',
          /[0-9]/,
          /[0-9]/,
          /[0-9]/,
          '/',
          /[0-9]/,
          /[0-9]/,
          /[0-9]/,
          /[0-9]/,
          '-',
          /[0-9]/,
          /[0-9]/,
        ];
      }
    } catch (error) {}
  }

  static foneMask(rawValue) {
    try {
      var numbers = rawValue.match(/\d/g);

      var numberLength = 0;
      if (numbers) {
        numberLength = numbers.join('').length;
      }
      if (numberLength <= 10) {
        return [
          '(',
          /[0-9]/,
          /[0-9]/,
          ')',
          ' ',
          /[0-9]/,
          /[0-9]/,
          /[0-9]/,
          /[0-9]/,
          '-',
          /[0-9]/,
          /[0-9]/,
          /[0-9]/,
          /[0-9]/,
        ];
      } else {
        return [
          '(',
          /[0-9]/,
          /[0-9]/,
          ')',
          ' ',
          /[0-9]/,
          ' ',
          /[0-9]/,
          /[0-9]/,
          /[0-9]/,
          /[0-9]/,
          '-',
          /[0-9]/,
          /[0-9]/,
          /[0-9]/,
          /[0-9]/,
        ];
      }
    } catch (error) {}
  }

  static cepMask(rawValue) {
    return [
      /[0-9]/,
      /[0-9]/,
      '.',
      /[0-9]/,
      /[0-9]/,
      /[0-9]/,
      '-',
      /[0-9]/,
      /[0-9]/,
      /[0-9]/,
    ];
  }

  static cpfMask(rawValue) {
    return [
      /[0-9]/,
      /[0-9]/,
      /[0-9]/,
      '.',
      /[0-9]/,
      /[0-9]/,
      /[0-9]/,
      '.',
      /[0-9]/,
      /[0-9]/,
      /[0-9]/,
      '-',
      /[0-9]/,
      /[0-9]/,
    ];
  }
  static cnpjMask(rawValue) {
    return [
      /[0-9]/,
      /[0-9]/,
      '.',
      /[0-9]/,
      /[0-9]/,
      /[0-9]/,
      '.',
      /[0-9]/,
      /[0-9]/,
      /[0-9]/,
      '/',
      /[0-9]/,
      /[0-9]/,
      /[0-9]/,
      /[0-9]/,
      '-',
      /[0-9]/,
      /[0-9]/,
    ];
  }

  static dataMask(rawValue) {
    return [/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/];
  }

  static validadeCartaoCreditoMask(rawValue) {
    return [/\d/, /\d/, '/', /\d/, /\d/];
  }
  static numeroCartaoCreditoMask(rawValue) {
    return [
      /\d/,
      /\d/,
      /\d/,
      /\d/,
      ' ',
      /\d/,
      /\d/,
      /\d/,
      /\d/,
      ' ',
      /\d/,
      /\d/,
      /\d/,
      /\d/,
      ' ',
      /\d/,
      /\d/,
      /\d/,
      /\d/,
    ];
  }

  static cepValidator(control: FormControl) {
    const cep = control.value;
    if (cep && cep !== '') {
      let teste = cep.match(/\d/g);
      const validacep = /^[0-9]{8}$/;
      return validacep.test(teste.join('')) ? null : { cepInvalido: true };
    }
    return null;
  }

  static equalsTo(otherField: string) {
    const validator = (formControl: FormControl) => {
      if (otherField == null) {
        throw new Error('É necessário informar um campo.');
      }

      if (!formControl.root || !(<FormGroup>formControl.root).controls) {
        return null;
      }

      const field = (<FormGroup>formControl.root).get(otherField);

      if (!field) {
        throw new Error('É necessário informar um campo válido.');
      }

      if (field.value !== formControl.value) {
        return { equalsTo: otherField };
      }

      return null;
    };
    return validator;
  }

  static getErrorMsg(
    fieldName: string,
    validatorName: string,
    validatorValue?: any
  ) {
    const config = {
      required: `${fieldName} é obrigatório.`,
      minlength: `${fieldName} precisa ter no mínimo ${validatorValue.requiredLength} caracteres.`,
      maxlength: `${fieldName} precisa ter no máximo ${validatorValue.requiredLength} caracteres.`,
      cepInvalido: 'CEP inválido.',
      documentoCadastrado: 'Este documento já foi cadastrado',
      email: 'E-mail inválido',
      emailInvalido: 'Email já cadastrado!',
      equalsTo: 'A senha deve ser igual a confirmação da senha ',
      pattern: 'Campo inválido',
      bsDate: 'Data inválida',
      cpfInvalido: `${fieldName} inválido`,
      cnpjInvalido: `${fieldName} inválido`,
      codigoExistente: 'Codigo já cadastrado!',
      max: `O valor máximo é ${validatorValue.max}`,
      min: `O valor mínino é ${validatorValue.min}`,
      nomeCompletoInvalido: `O nome deve ser completo`,
    };

    return config[validatorName];
  }
}
